import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell';
import { ComingSoon } from '@/components/shared/ComingSoon';

export const Route = createFileRoute('/ponudbe')({
  component: PonudbePage,
});

function PonudbePage() {
  return (
    <AppShell pageTitle="Ponudbe" crumb="TradeCraft · Ponudbe">
      <ComingSoon
        headline="Ponudbe"
        lead="Ustvarite profesionalne ponudbe z DDV, pošljite stranki v PDF in sledite statusu — vse na enem mestu."
      />
    </AppShell>
  );
}
